import axiosInstance from '@client/utils/axios.util';
import { logger } from '@client/utils/logger.util';

import type { ILedgerEntry, IWallet, ELedgerKind } from '@common/types';

export interface IGrantCreditsPayload {
  userId: string;
  tenantId: string;
  amount: number;
  kind: ELedgerKind;
  referenceId: string;
  idempotencyKey: string;
}

export interface ICreditsLedgerResponse {
  entries: ILedgerEntry[];
  total: number;
}

export const getCreditsBalance = async (
  tenantId?: string,
  userId?: string,
): Promise<IWallet> => {
  try {
    const { data } = await axiosInstance.get<IWallet>('/credits/balance', {
      params: { tenantId, userId },
    });
    return data;
  } catch (error) {
    logger.error('getCreditsBalance', error);
    throw error;
  }
};

export const getCreditsLedger = async (
  limit: number,
  offset: number,
  tenantId?: string,
  userId?: string,
): Promise<ICreditsLedgerResponse> => {
  try {
    const { data } = await axiosInstance.get<ICreditsLedgerResponse>(
      '/credits/ledger',
      { params: { limit, offset, tenantId, userId } },
    );
    return data;
  } catch (error) {
    logger.error('getCreditsLedger', error);
    throw error;
  }
};

export const grantCredits = async (
  payload: IGrantCreditsPayload,
): Promise<IWallet> => {
  try {
    const { data } = await axiosInstance.post<IWallet>(
      '/credits/grant',
      payload,
    );
    return data;
  } catch (error) {
    logger.error('grantCredits', error);
    throw error;
  }
};
